import {
  ILayout_Editor,
  ILayout_Cell_Props_Empty,
} from '@kaidam/fc-shared/src/types/layout'

/*

  EDITOR

*/
const EmptyEditor: ILayout_Editor<ILayout_Cell_Props_Empty> = ({

}) => {
  
  return null
}

export default EmptyEditor
